// extracted by mini-css-extract-plugin
export default {"image":"uW-z","loaded":"vW-z"};